module.exports = __webpack_public_path__ + "img/chart-line.88bf310e.svg";